module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/paid-4001835b838ed21e0cc7dd58c9328ea7.png";